import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDown } from 'lucide-react';
import { cn } from './cn';

/**
 * Dropdown (Headless UI Menu). Mặc định trigger là nút secondary; có thể truyền `renderTrigger`.
 */
export function Dropdown({ label, icon: Icon, renderTrigger, align = 'right', menuClassName, triggerClassName, children }) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {renderTrigger ? (
        <Menu.Button as={Fragment}>{renderTrigger}</Menu.Button>
      ) : (
        <Menu.Button className={cn('btn btn-secondary', triggerClassName)}>
          {Icon ? <Icon className="w-4 h-4" aria-hidden="true" /> : null}
          {label}
          <ChevronDown className="w-4 h-4 -mr-1 opacity-70" aria-hidden="true" />
        </Menu.Button>
      )}
      <Transition
        as={Fragment}
        enter="transition ease-out duration-150"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items
          className={cn(
            'absolute z-40 mt-2 min-w-[12rem] origin-top rounded-xl border border-line bg-surface-raised p-1.5 shadow-lg focus:outline-none',
            align === 'right' ? 'right-0' : 'left-0',
            menuClassName
          )}
        >
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export function DropdownItem({ icon: Icon, children, danger = false, className, ...props }) {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          type="button"
          className={cn(
            'flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
            active ? 'bg-gray-100 dark:bg-gray-800 text-heading' : 'text-body',
            danger && 'text-red-600 dark:text-red-400',
            className
          )}
          {...props}
        >
          {Icon ? <Icon className="w-4 h-4 flex-shrink-0" aria-hidden="true" /> : null}
          {children}
        </button>
      )}
    </Menu.Item>
  );
}

export function DropdownDivider() {
  return <div className="my-1 border-t border-line" role="separator" />;
}

export function DropdownLabel({ children }) {
  return <div className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-muted">{children}</div>;
}

export default Dropdown;
